// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bj-tc","type":"styles_type__2HIUy","choices":"styles_choices__3a11m"};